import { Stack } from '@mui/material';
import { RefObject, useRef } from 'react';
import { ImperativeFormDialogRefType } from '@shared/components/UserFormDialog';
import { ClientWithVisitsWithVisitServices } from '../entity';
import { VisitFormDialog } from '@features/visits/components/visit-form/visit-form-dialog';
import { ClientContactButtons } from './client-contact-buttons';
import { ClientContactInfo } from './client-contact-info';

const ClientProfileActions = (props: {
  dialogRef: RefObject<ImperativeFormDialogRefType | null>;
  clientData: ClientWithVisitsWithVisitServices;
}) => {
  const { clientData, dialogRef } = props;
  const visitFormDialogRef = useRef<ImperativeFormDialogRefType | null>(null);

  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <ClientContactInfo
          clientData={clientData}
          onEdit={() => dialogRef.current?.open('firstName')}
        />
        <ClientContactButtons
          phone={clientData.phone}
          phonePrefix={clientData.phonePrefix}
          onMakeOrder={() => visitFormDialogRef.current?.open()}
        />
      </Stack>
      <VisitFormDialog dialogRef={visitFormDialogRef} />
    </>
  );
};

export default ClientProfileActions;
